import edit from './edit';
import save from './save';
import { accordionIcon as icon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json'; // eslint-disable-line
import accItemBlockMeta from './block.json';
import './style.scss';

const { registerBlockType } = wp.blocks;

const { name, ...settings } = accItemBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
};

registerBlockType(name, {
  icon,
  attributes,
  edit,
  save,
});
